import { render, staticRenderFns } from "./MessageNotifications.vue?vue&type=template&id=6da59ee6&scoped=true"
import script from "./MessageNotifications.vue?vue&type=script&lang=js"
export * from "./MessageNotifications.vue?vue&type=script&lang=js"
import style0 from "./MessageNotifications.vue?vue&type=style&index=0&id=6da59ee6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da59ee6",
  null
  
)

export default component.exports